import type { ITagChip } from './ITagChip';
import type { ITagSuggestions } from './ITagSuggestions';
import { normalizeTagName } from './normalizeTagName';

/**
 * Підказки поля тегів (UIUX/controls/tag-input; прототип onTagIn): невибрані теги, що містять запит, спершу ті, що з нього
 * починаються, далі за абеткою, не більше 8; «Створити» — коли запит непорожній і такого тега (без регістру) ще немає.
 */
export function tagSuggestions(all: ITagChip[], selected: string[], query: string, limit = 8): ITagSuggestions {
  const q = query.trim().toLowerCase();
  const chosen = new Set(selected.map((s) => s.toLowerCase()));
  const items = all
    .filter((t) => !chosen.has(t.key.toLowerCase()) && !chosen.has(t.label.toLowerCase()) && (!q || t.label.toLowerCase().includes(q)))
    .sort((a, b) => Number(!a.label.toLowerCase().startsWith(q)) - Number(!b.label.toLowerCase().startsWith(q)) || a.label.localeCompare(b.label))
    .slice(0, limit);
  const name = normalizeTagName(query);
  const exists = all.some((t) => t.label.toLowerCase() === name || t.label.toLowerCase() === q) || chosen.has(name);
  return { items, create: name && !exists ? name : null };
}
